// Download folder / beberapa file sekaligus sebagai satu file ZIP, SAMBIL
// mengalir (streaming): tiap potongan file diambil dari Discord, didekripsi
// kalau perlu, lalu langsung ditulis ke ZIP - tidak perlu menampung semuanya
// di memori dulu (kecuali di browser HP tanpa service worker, lihat bawah).
//
// Dipakai terutama di HP: download folder biasa butuh showDirectoryPicker,
// yang cuma ada di Chrome/Edge desktop.
import { downloadZip } from 'client-zip';
import { fetchUrl } from './disbox-file-manager';
import { pickLocationAsWritable } from './file-utils';

export function collectZipEntries(fileManager, rows) {
    const entries = [];
    const addDirectory = (dirPath, prefix) => {
        const children = Object.values(fileManager.getChildren(dirPath));
        for (const child of children) {
            if (child.type === 'directory') {
                entries.push({ name: `${prefix}${child.name}/`, folder: true });
                addDirectory(child.path, `${prefix}${child.name}/`);
            } else if (child.content) {
                entries.push({ name: `${prefix}${child.name}`, node: child });
            }
        }
    };
    for (const row of rows) {
        if (row.type === 'directory') {
            entries.push({ name: `${row.name}/`, folder: true });
            addDirectory(row.path, `${row.name}/`);
        } else if (row.content) {
            entries.push({ name: row.name, node: row });
        }
    }
    return entries;
}

export function totalZipBytes(entries) {
    return entries.reduce((sum, entry) => sum + (entry.node ? Number(entry.node.size) || 0 : 0), 0);
}

// Apakah browser ini bisa menulis download langsung ke disk sambil mengalir?
// (Chrome/Edge desktop, atau web yang dibuka lewat https dengan service worker.)
export function canStreamToDisk() {
    return typeof window.showSaveFilePicker === 'function'
        || Boolean(navigator.serviceWorker && navigator.serviceWorker.controller);
}

function fileStream(fileManager, node, onBytes) {
    let urls = null;
    let decrypt = null;
    let index = 0;
    return new ReadableStream({
        async pull(controller) {
            if (!urls) {
                urls = await fileManager.getAttachmentUrls(node.path);
                decrypt = fileManager.getDecryptor(fileManager.getFile(node.path));
            }
            if (index >= urls.length) {
                controller.close();
                return;
            }
            let blob = await fetchUrl(urls[index++]);
            if (decrypt) blob = await decrypt(blob);
            controller.enqueue(new Uint8Array(await blob.arrayBuffer()));
            onBytes(blob.size);
        },
    });
}

export async function downloadAsZip(fileManager, rows, zipName, onProgress) {
    const entries = collectZipEntries(fileManager, rows);
    if (entries.filter((e) => e.node).length === 0) throw new Error('Tidak ada file untuk di-ZIP.');
    const totalBytes = totalZipBytes(entries);
    const counter = { done: 0 };
    const onBytes = (bytes) => {
        counter.done += bytes;
        if (onProgress) onProgress(counter.done, totalBytes);
    };
    const files = (async function* generate() {
        for (const entry of entries) {
            if (entry.folder) {
                yield { name: entry.name, lastModified: new Date() };
                continue;
            }
            yield {
                name: entry.name,
                lastModified: new Date(entry.node.updated_at || entry.node.created_at || Date.now()),
                size: Number(entry.node.size) || 0,
                input: fileStream(fileManager, entry.node, onBytes),
            };
        }
    })();
    const writer = await pickLocationAsWritable(zipName);
    const reader = downloadZip(files).body.getReader();
    try {
        for (;;) {
            const { done, value } = await reader.read();
            if (done) break;
            await writer.write(value);
        }
        await writer.close();
    } catch (error) {
        try {
            await writer.abort(error);
        } catch { /* sudah tertutup */ }
        throw error;
    }
    if (onProgress) onProgress(totalBytes, totalBytes);
}
